<template>
  <div v-if="quote && content" class="mb-8">
    <order-summary-card
      :done="true"
      :quote="quote"
      :productsServices="productsServices"
      :showProductsServices="showProductsServices"
    ></order-summary-card>
  </div>
</template>

<script>
import OrderSummaryCard from './OrderSummaryCard'

export default {
  name: 'OrderSummaryCardConfirmation',
  props: ['quote', 'productsServices', 'showProductsServices'],
  components: {
    OrderSummaryCard,
  },
}
</script>
